import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import OpportunityCard from "@/components/OpportunityCard";

export default function FeaturedOpportunities({ opportunities = [], eyebrow, heading }) {
  const navigate = useNavigate();
  const items = opportunities.slice(0, 6);
  if (!items.length) return null;

  return (
    <section id="opportunities" data-testid="featured-opportunities" className="border-t border-gold/10 bg-obsidian px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <Eyebrow>{eyebrow || "Featured Opportunities"}</Eyebrow>
              <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">
                {heading || "A selection of what passes our desk."}
              </h2>
            </div>
            <button onClick={() => navigate("/opportunities")} data-testid="view-all-opportunities"
                    className="flex items-center gap-2 border border-gold/40 px-6 py-3 font-sans text-sm text-warmwhite transition-colors hover:bg-gold/10">
              View All Opportunities <ArrowRight size={15} className="text-gold" />
            </button>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((opp, i) => (
            <Reveal key={opp.id} delay={i * 0.06}>
              <OpportunityCard opp={opp} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
